import React from "react";

const STYLES = {
  pending:    "bg-amber-400/10 text-amber-400 border-amber-400/30",
  active:     "bg-[#00FF99]/10 text-[#00FF99] border-[#00FF99]/30",
  inactive:   "bg-white/5 text-white/50 border-white/10",
  offboarded: "bg-red-500/10 text-red-400 border-red-500/30",
};

const LABELS = {
  pending:    "Pending",
  active:     "Active",
  inactive:   "Inactive",
  offboarded: "Offboarded",
};

const titleCase = (s) =>
  String(s).replace(/[_-]+/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export default function StatusBadge({ status, className = "" }) {
  const key = String(status || "").toLowerCase();
  const known = STYLES[key];
  const style = known || STYLES.inactive;
  const label = known ? LABELS[key] : (status ? titleCase(status) : "Inactive");
  return (
    <span
      className={`inline-block px-2 py-0.5 rounded-full text-xs border ${style} ${className}`.trim()}
    >
      {label}
    </span>
  );
}
